import { Cartesian3, Cartographic } from "cesium";

export function getElevatedCesiumPoint(point: Cartesian3, newHeight: number): Cartesian3 {
    const cartographic = Cartographic.fromCartesian(point);
    cartographic.height = newHeight;

    return Cartographic.toCartesian(cartographic);
}
